export default __webpack_public_path__ + "static/media/012-cctv-1.e9c9d7b4.png";